import {
  PostSimulationExecuteRes,
  PostSimulationExecuteReqParams
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

export class SimulationExecuteGateway {
  static postSimulationExecute = async (
    params: PostSimulationExecuteReqParams
  ) => {
    return await yamadumiApi.post<PostSimulationExecuteRes>(
      '/api/simulation/execute', { data: params }, { disableCommonErrorHandling: true }
    )
  }
}
